import React from 'react';

import { Container } from './styles';

const SimpleText: React.FC<any> = (props) => {
  const { style, data } = (props as unknown) as any;

  return (
    <Container style={style}>
      {data.map((value: string) => (
        <h3>{value}</h3>
      ))}
    </Container>
  );
};

export default SimpleText;
